import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./routes/Layout";
import Feedback from "./routes/Feedback";
import Login from "./routes/Login";
import Home from "./routes/Home";
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext";
import { SnackbarProvider } from "./context/SnackbarContext";

export default function Router() {
  const { user } = useContext(AuthContext);
  return (
    <SnackbarProvider>
      <Routes>
        <Route path="/" element={<Layout />}></Route>
        <Route index element={<Feedback />} />
        <Route path="login" element={user ? <Home /> : <Login />} />
        <Route path="home" element={user ? <Home /> : <Feedback />} />
      </Routes>
    </SnackbarProvider>
  );
}
